import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Component, forwardRef, Input, OnDestroy} from '@angular/core';
import {AbstractControl, ControlValueAccessor, FormBuilder, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors} from '@angular/forms';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {concatMap, map, tap} from 'rxjs/operators';
import {DISPLAY_DIRECTION, FC_CONTROLS_USERDATAFROM, IUserData} from './user-data.model';
import { TRANSLATE_PATH as TRANSLATE_PATH_PROJECT } from '../../project.model';
import {TRANSLATE_PATH as TRANSLATE_PATH_SHARED} from 'src/app/shared/shared.model'
import {IIdentifier, ResponseLoadUserData} from 'build/project/openapi-cast/project/project-openapi-cast.model';
import { ProjectOpenapiCastService } from 'build/project/openapi-cast/project/project-openapi-cast.service'

@Component({
   selector: 'app-user-data',
   templateUrl: './user-data.component.html',
   styleUrls: ['./user-data.component.scss'],
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => UserDataComponent)
      },
      {
         provide: NG_VALIDATORS,
         multi: true,
         useExisting: UserDataComponent
      }
   ],
   standalone: false
})
export class UserDataComponent implements OnDestroy, ControlValueAccessor {

   public TRANSLATE_PATH_PROJECT: typeof TRANSLATE_PATH_PROJECT = TRANSLATE_PATH_PROJECT;
   public TRANSLATE_PATH_SHARED: typeof TRANSLATE_PATH_SHARED = TRANSLATE_PATH_SHARED; 
   public DISPLAY_DIRECTION: typeof DISPLAY_DIRECTION = DISPLAY_DIRECTION; 
   public FC_CONTROLS_USERDATAFROM: typeof FC_CONTROLS_USERDATAFROM = FC_CONTROLS_USERDATAFROM;

   public userDataForm: FormGroup = this.fb.group({});
   private loaded_: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   public loaded$: Observable<boolean> = this.loaded_.asObservable();
   private iUserData_: IUserData = {} as IUserData;
   private id_: IIdentifier = {} as IIdentifier;
   public isFirstname: boolean = false;
   public isLastname: boolean = false;
   public bankaccounts: string[] = [];
   public isCustomer: boolean = false;
   public userData: ResponseLoadUserData = {} as ResponseLoadUserData;

   @Input()
   get id (): IIdentifier {
      return this.id_;
   }

   set id (iid: IIdentifier) {
      this.reset();
      if (!iid) return;
      this.loaded_.next(false);
      this.sProjectOpenapi.loadUserData().subscribe(userData => {
         this.initializeFormGroup(userData);
         this.userData = userData;
         this.loaded_.next(this.checkDataExists(userData))
      });
      this.id_ = iid;
   }

   @Input()
   set value (val: IUserData) {
      this.iUserData_ = val;
   }

   get value (): IUserData {
      return this.iUserData_;
   }

   constructor (public sProjectOpenapi: ProjectOpenapiCastService, private fb: FormBuilder) {
     
   }

   ngOnDestroy (): void {
      this.reset();
   }

   writeValue (_obj: any): void {
   }

   registerOnChange (_fn: any): void {
   }

   registerOnTouched (_fn: any): void {
   }

   setDisabledState? (_isDisabled: boolean): void {
   }

   validate (_control: AbstractControl): ValidationErrors | null {
      this.userDataForm.updateValueAndValidity({emitEvent: true, onlySelf: true});
      return this.userDataForm.invalid ? {invalid: true} : null;
   }

   private initializeFormGroup (userData: ResponseLoadUserData): void {
      this.userDataForm = this.fb.group({
      });

      this.isFirstname = !(userData && userData.firstname && userData.firstname != "-1") ? false : true;
      if (this.isFirstname) this.userDataForm.addControl(FC_CONTROLS_USERDATAFROM.FIRSTNAME, this.fb.control({
         value: userData.firstname, 
         disabled: true
      }));

      this.isLastname = !(userData && userData.lastname && userData.lastname != "-1") ? false : true;
       if (this.isLastname)  this.userDataForm.addControl(FC_CONTROLS_USERDATAFROM.LASTNAME, this.fb.control({
         value: userData.lastname,
         disabled: true
      }));

      this.bankaccounts = !(userData && userData.bankaccount) ? [] : userData.bankaccount === "-1" ? [] : userData.bankaccount.split(";");
      if (this.bankaccounts.length > 0) this.bankaccounts.forEach((value: string, index) => {
         this.userDataForm.addControl(FC_CONTROLS_USERDATAFROM.BANKACCOUNT + (index + 1), this.fb.control({
            value: value && value == "-1" ? '' : value,
            disabled: true
         }));
      });

      this.isCustomer = !(userData && userData.customer && userData.customer == "-1") ? false : true;
      if (this.isCustomer) this.userDataForm.addControl(FC_CONTROLS_USERDATAFROM.CUSTOMER, this.fb.control({
         value: userData.customer,
         disabled: true
      }));
   }

   private checkDataExists (userData: ResponseLoadUserData): boolean {
      return Object.keys(userData).length == 0 || Object.keys(userData).filter((key: string) => userData[key as keyof ResponseLoadUserData] != "").length == 0 ? false : true;
   }

   private reset (): void {
      this.userDataForm = this.fb.group({});
   }
}
